// extracted by mini-css-extract-plugin
export default {"searchOptions":"companies-filter_searchOptions__H4gQV","option":"companies-filter_option__n8hKn"};